import { AJOObject, AJOUpdater } from 'mp-js-react-auto-json-object';
import { Col } from '../table/Col';
import Table from '../table/Table';
import Category from '../../object/tag/Category';
import { TagList } from '../../component/TagList';
import { SelectTagListModal } from '../../modal/vendor/SelectTagListModal';
import AppManager from '../AppManager';
import Permission from '../../object/Permission';
import { TagListFetch } from '../../component/TagListFetch';

export interface CategoryColInterface {
    CategoryColInterface: boolean;
    getCategoryList(): Category[];
}

export class CategoryCol<Type extends AJOObject> extends Col<Type> {
    private canAdd: boolean = false;
    private parent: AJOObject | null = null;

    constructor(
        table: Table<Type>,
        canEdit: boolean = false,
        canAdd: boolean = false,
        canDelete: boolean = false,
        get: (elem: Type) => AJOObject | null = (elem) => elem,
        name: string = 'Catégorie',
        selectCategory: (cate: Category[]) => void = () => {},
        cate: Category[] = [],
        parent: AJOObject | null = null,
    ) {
        super(name);

        this.parent = parent;
        this.canAdd = canAdd;

        this.table = table;
        this.render = (elem: Type) => {
            if (get(elem) == null) {
                return <p>Aucun fournisseur, aucune prestation</p>;
            } else if ('CategoryColInterface' in get(elem)!) {
                canEdit = canEdit && AppManager.hasPermission(Permission.MANAGE_CATEGORY);
                canAdd = canAdd && AppManager.hasPermission(Permission.MANAGE_CATEGORY);
                canDelete = canDelete && AppManager.hasPermission(Permission.MANAGE_CATEGORY);

                let inter = get(elem) as unknown as CategoryColInterface;
                let res;
                res = (
                    <div className="flex gap-2 flex-wrap">
                        <TagList
                            loading={false}
                            canAdd={canAdd}
                            canEdit={canEdit}
                            field={'category'}
                            list={inter.getCategoryList()}
                            canDelete={canDelete}
                            parent={elem}
                        ></TagList>
                    </div>
                );
                return res;
            } else {
                throw new Error('CategoryColInterface not found in elem');
            }
        };
        this.sort = (a: Type, b: Type) => {
            if (get(a) != null && get(b) != null) {
                return 0;
            } else if ('CategoryColInterface' in get(a)! && 'CategoryColInterface' in get(b)!) {
                let aInter = get(a) as unknown as CategoryColInterface;
                let bInter = get(b) as unknown as CategoryColInterface;
                return -aInter.getCategoryList().length + bInter.getCategoryList().length;
            } else {
                throw new Error('CategoryColInterface not found in a or b');
            }
        };
        const obj = this;
        this.update(cate, selectCategory);
        this.renderFilterModal = () => {
            return <SelectTagListModal field="category" col={obj} />;
        };
        this.filter = (elem: Type) => {
            if (get(elem) == null) {
                return false;
            } else if ('CategoryColInterface' in get(elem)!) {
                let inter = get(elem) as unknown as CategoryColInterface;
                let can = obj.filterList.length === 0;
                let i = 0;
                // check if service has category in elem list of category row
                while (!can && i < obj.filterList.length) {
                    can =
                        inter
                            .getCategoryList()
                            .find((e: Category) => e.getAjoIdentifier() == obj.filterList[i].getAjoIdentifier()) !=
                        undefined;
                    i++;
                }
                return can;
            } else {
                throw new Error('CategoryColInterface not found in elem');
            }
        };
        this.typeRender = 'info';
        this.type = 'sort_filter';
        this.senseSort = 0;
    }

    public update(cate: Category[], selectCategory: (cate: Category[]) => void = () => {}) {
        const obj = this;
        this.renderTopRow = () => {
            if (obj.parent != null) {
                if ('CategoryColInterface' in obj.parent) {
                    let inter = obj.parent as unknown as CategoryColInterface;

                    let canAdd = obj.canAdd && AppManager.hasPermission(Permission.MANAGE_CATEGORY);

                    return (
                        <TagListFetch
                            simple={true}
                            selectList={cate}
                            onSelectList={selectCategory}
                            canAdd={canAdd}
                            field={'category'}
                        />
                    );
                } else {
                    throw new Error('CategoryColInterface not found in parent');
                }
            }
        };
    }
}
